import register from '@/components/features/cms/blocks/AvatarLink/register';
import { AvatarLink } from './AvatarLink';

register(AvatarLink);
